// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30mcv","root__whitelabel":"styles_root__whitelabel__2y1XP","headingContainer":"styles_headingContainer__TFwbi"};